import React from 'react';

interface IconProps {
    width: string;
    height: string;
    className?: string;
}

interface IconFixed {
    className?: string;
}

export interface IconFlexible extends IconProps {
    stroke?: string;
}

export const IconChevron: React.FC<IconFlexible> = ({ width, height, stroke, className }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 16 10'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            d={'M15 1.00027L8 8.01074L1 1.00028'}
            stroke={stroke}
            strokeWidth={'2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
    </svg>
);

export const IconArrow: React.FC<IconFlexible & { strokeWidth?: number }> = ({
    width,
    height,
    stroke = 'currentColor',
    className,
    strokeWidth = 2
}) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 18 12'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            d={'M11.6663 1.33329L16.333 5.99996M16.333 5.99996L11.6663 10.6666M16.333 5.99996L1.33301 5.99996'}
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
    </svg>
);

export const IconBackHome: React.FC<IconFlexible & { strokeWidth?: number }> = ({
    width,
    height,
    stroke,
    className,
    strokeWidth = 2
}) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 16 17'}
        fill={'#242E35'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            d={
                'M7.15114 2.09331C7.63056 1.63833 8.38132 1.63521 8.8645 2.08618L12.869 5.82367C13.1718 6.10629 13.6464 6.08993 13.929 5.78712C14.2116 5.4843 14.1952 5.00971 13.8924 4.72708L9.88798 0.989598C8.82497 -0.00254884 7.1733 0.00432141 6.11857 1.00528L0.933139 5.92635C0.386006 6.4456 0.0761719 7.16678 0.0761719 7.92108V14.0364C0.0761719 15.5552 1.30739 16.7864 2.82617 16.7864H5.95047H10.0499H13.1742C14.693 16.7864 15.9242 15.5552 15.9242 14.0364V12.5919V10.2972C15.9242 9.88297 15.5884 9.54718 15.1742 9.54718C14.76 9.54718 14.4242 9.88297 14.4242 10.2972V12.5919V14.0364C14.4242 14.7268 13.8646 15.2864 13.1742 15.2864H10.185V10.797C10.185 10.1067 9.62533 9.54701 8.93497 9.54701H7.06537C6.37501 9.54701 5.81537 10.1067 5.81537 10.797V15.2864H2.82617C2.13582 15.2864 1.57617 14.7268 1.57617 14.0364V7.92108C1.57617 7.57822 1.71701 7.2504 1.9657 7.01439L7.15114 2.09331ZM7.31537 15.2862V11.047H8.68497V15.2862H7.31537Z'
            }
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
    </svg>
);

export const IconHamburger: React.FC<IconFlexible> = ({ width, height, stroke, className }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 32 22'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <line y1={'1'} x2={'32'} y2={'1'} strokeWidth={'2'} stroke={stroke} />
        <line y1={'11'} x2={'32'} y2={'11'} strokeWidth={'2'} stroke={stroke} />
        <line y1={'21'} x2={'32'} y2={'21'} strokeWidth={'2'} stroke={stroke} />
    </svg>
);

export const IconClose: React.FC<IconFlexible> = ({ width, height, stroke, className }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 16 16'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M14.9874 2.35268C15.3779 1.96215 15.3779 1.32899 14.9874 0.938462C14.5969 0.547938 13.9637 0.547938 13.5732 0.938462L7.64014 6.8715L1.70711 0.938462C1.31658 0.547938 0.683417 0.547938 0.292893 0.938462C-0.0976311 1.32899 -0.0976311 1.96215 0.292893 2.35268L6.22593 8.28571L0.292893 14.2188C-0.0976311 14.6093 -0.0976311 15.2424 0.292893 15.633C0.683417 16.0235 1.31658 16.0235 1.70711 15.633L7.64014 9.69993L13.5732 15.633C13.9637 16.0235 14.5969 16.0235 14.9874 15.633C15.3779 15.2424 15.3779 14.6093 14.9874 14.2188L9.05436 8.28571L14.9874 2.35268Z'
            }
            fill={stroke}
        />
    </svg>
);

export const IconCloseOutlined: React.FC<IconFlexible> = ({ width, height, stroke, className }) => (
    <svg width={width} height={height} className={className} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <circle cx={'16'} cy={'16'} r={'15'} stroke={stroke} strokeWidth={'2'} />
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M21.1372 12.6667C21.5278 12.2762 21.5278 11.643 21.1372 11.2525C20.7467 10.862 20.1135 10.862 19.723 11.2525L16.1948 14.7807L12.6666 11.2525C12.2761 10.862 11.6429 10.862 11.2524 11.2525C10.8618 11.643 10.8618 12.2762 11.2524 12.6667L14.7806 16.1949L11.2524 19.7231C10.8618 20.1137 10.8618 20.7468 11.2524 21.1373C11.6429 21.5279 12.2761 21.5279 12.6666 21.1373L16.1948 17.6091L19.723 21.1373C20.1135 21.5279 20.7467 21.5279 21.1372 21.1373C21.5278 20.7468 21.5278 20.1137 21.1372 19.7231L17.609 16.1949L21.1372 12.6667Z'
            }
            fill={stroke}
        />
    </svg>
);

export const IconUser: React.FC<IconFlexible> = ({ width, height, stroke, className }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 44 44'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <circle cx={'22'} cy={'22'} r={'21.25'} stroke={stroke} strokeWidth={'1.5'} />
        <path
            d={
                'M22.001 21.8553C23.9932 21.8553 25.501 20.0428 25.501 17.6444C25.501 15.7303 23.8994 14.1053 22.001 14.1053C20.1026 14.1053 18.501 15.7303 18.501 17.6444C18.501 20.0428 20.0088 21.8553 22.001 21.8553ZM22.001 15.3163C23.2119 15.3163 24.2823 16.41 24.2823 17.6444C24.2823 19.3553 23.3057 20.6444 22.001 20.6444C20.6963 20.6444 19.7198 19.3553 19.7198 17.6444C19.7198 16.41 20.7901 15.3163 22.001 15.3163ZM16.7588 28.1053L16.8682 26.9413C17.1104 24.5975 19.7823 24.0819 22.001 24.0819C24.2198 24.0819 26.8916 24.5975 27.1338 26.9335L27.2432 28.1053H28.4932L28.3838 26.8163C28.1104 24.2616 25.8604 22.8553 22.001 22.8553C18.1416 22.8553 15.8916 24.2616 15.6182 26.8241L15.5088 28.1053H16.7588Z'
            }
            fill={stroke}
        />
    </svg>
);

export const IconLightBulb: React.FC<IconFlexible> = ({ width, height, stroke, className }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 26 28'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            d={
                'M9.70748 20.7162H15.9784C16.1826 19.1866 17.1309 17.9243 18.67 16.5461C18.8448 16.3909 19.957 15.4429 20.0884 15.308C21.181 14.1851 21.8658 12.8313 22.064 11.4023C22.2622 9.97334 21.9657 8.52737 21.2088 7.23093C20.4518 5.93448 19.2651 4.84029 17.7853 4.07435C16.3056 3.30841 14.5929 2.90188 12.8446 2.90158C11.0963 2.90127 9.38347 3.3072 7.90332 4.07262C6.42316 4.83803 5.2359 5.93181 4.47826 7.22799C3.72062 8.52417 3.42342 9.97003 3.62088 11.3991C3.81835 12.8281 4.50244 14.1822 5.59438 15.3054C5.72741 15.4416 6.8427 16.3909 7.0144 16.5449C8.55507 17.9243 9.50329 19.1866 9.70748 20.7162ZM15.9367 23.2612H9.74924V24.5338H15.9367V23.2612ZM3.18128 16.8986C1.72443 15.4012 0.811411 13.5957 0.547388 11.6901C0.283364 9.78454 0.679081 7.85633 1.68895 6.12766C2.69883 4.39898 4.28177 2.94015 6.25544 1.91921C8.22911 0.898281 10.5132 0.356779 12.8446 0.357086C15.1761 0.357393 17.4599 0.899497 19.4332 1.92095C21.4065 2.9424 22.9889 4.40165 23.9981 6.13059C25.0073 7.85954 25.4022 9.78785 25.1375 11.6934C24.8727 13.5989 23.959 15.4042 22.5015 16.9012C21.5425 17.8836 19.0304 19.4437 19.0304 21.3525V24.5338C19.0304 25.2088 18.7045 25.8561 18.1243 26.3334C17.5441 26.8107 16.7572 27.0788 15.9367 27.0788H9.74924C8.92874 27.0788 8.14184 26.8107 7.56165 26.3334C6.98147 25.8561 6.65552 25.2088 6.65552 24.5338V21.3525C6.65552 19.4437 4.14188 17.8836 3.18128 16.8986ZM14.3898 10.5411H18.257L11.2961 18.1762V13.0861H7.42895L14.3898 5.44591V10.5424V10.5411Z'
            }
            fill={stroke}
        />
    </svg>
);

export const IconCheck: React.FC<IconFlexible> = ({ width, height, stroke, className }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 16 11'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            d={
                'M15.6431 1.7186C16.0399 1.3345 16.0502 0.701417 15.6661 0.304578C15.282 -0.0922618 14.6489 -0.102585 14.2521 0.28152L5.60953 8.64675L1.65222 5.24201C1.23356 4.88181 0.602168 4.9292 0.241969 5.34786C-0.11823 5.76652 -0.0708397 6.39791 0.347819 6.75811L4.98923 10.7514C5.18498 10.9237 5.43267 11.0068 5.67851 10.9996C5.82612 10.9954 5.97305 10.9586 6.10768 10.8891C6.19589 10.8436 6.27846 10.7843 6.35204 10.7115L15.6431 1.7186Z'
            }
            fill={stroke}
        />
    </svg>
);
export const IconCircleCheckFlexible: React.FC<IconFlexible> = ({ width, height, stroke, className }) => (
    <svg
        className={className}
        width={width}
        height={height}
        stroke={stroke}
        x-description={'Heroicon name: solid/check-circle'}
        xmlns={'http://www.w3.org/2000/svg'}
        viewBox={'0 0 20 20'}
        fill={'currentColor'}
        aria-hidden={'true'}
    >
        <path
            fillRule={'evenodd'}
            d={
                'M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
            }
            clipRule={'evenodd'}
        />
    </svg>
);

export const IconCircleCheck: React.FC<IconFixed> = ({ className }) => (
    <svg
        className={className}
        x-description={'Heroicon name: solid/check-circle'}
        xmlns={'http://www.w3.org/2000/svg'}
        viewBox={'0 0 20 20'}
        fill={'currentColor'}
        aria-hidden={'true'}
    >
        <path
            fillRule={'evenodd'}
            d={
                'M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
            }
            clipRule={'evenodd'}
        />
    </svg>
);

export const IconError: React.FC<IconFlexible> = ({ width, height, className, stroke = '#FF4D00' }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 24 24'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M1 12C1 5.92487 5.92487 1 12 1V1C18.0751 1 23 5.92487 23 12V12C23 18.0751 18.0751 23 12 23V23C5.92487 23 1 18.0751 1 12V12Z'
            }
            stroke={stroke}
            strokeWidth={'2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path d={'M12 7V13'} stroke={stroke} strokeWidth={'2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path d={'M12 16V17'} stroke={stroke} strokeWidth={'2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
    </svg>
);

export const IconInformation: React.FC<IconFlexible> = ({ width, height, className, stroke }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 18 18'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M9 17C4.58182 17 1 13.4182 1 9C1 4.58182 4.58182 1 9 1C13.4182 1 17 4.58182 17 9C17 13.4182 13.4182 17 9 17V17Z'
            }
            stroke={stroke}
            strokeWidth={'2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path d={'M9 13L9 9'} stroke={stroke} strokeWidth={'2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path
            d={'M9 6.09088L9 5.36361'}
            stroke={stroke}
            strokeWidth={'2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
    </svg>
);

export const IconCreditCard: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 23 19'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path d={'M1 5H22'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M20.0909 18.1818H2.90909C1.85432 18.1818 1 17.3275 1 16.2727V2.90909C1 1.85432 1.85432 1 2.90909 1H15.3182H20.0909C21.1457 1 22 1.85432 22 2.90909V16.2727C22 17.3275 21.1457 18.1818 20.0909 18.1818V18.1818Z'
            }
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path d={'M4.81836 11.4092H9.59109'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path d={'M17.2275 11.4092H18.1821'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
    </svg>
);

export const IconBankConnect: React.FC<IconFlexible> = ({ width, height, className }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 45 33'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={'M19.4135 3.42432L4 11.3371V15.2935H34.827V11.3371L19.4135 3.42432Z'}
            stroke={'#242424'}
        />
        <path d={'M16.6104 31.1198V15.2942'} stroke={'#242424'} />
        <path d={'M22.2168 15.2942V31.1198'} stroke={'#242424'} />
        <path d={'M6.80273 31.1198V15.2942'} stroke={'#242424'} />
        <path d={'M12.4072 15.2942V31.1198'} stroke={'#242424'} />
        <path d={'M26.4199 31.1198V15.2942'} stroke={'#242424'} />
        <path d={'M32.0244 15.2942V31.1198'} stroke={'#242424'} />
        <path d={'M0 31.3572H38.857'} stroke={'#242424'} />
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M18.0127 10.0188C18.0127 9.29077 18.6404 8.69995 19.4139 8.69995C20.1874 8.69995 20.8151 9.29077 20.8151 10.0188C20.8151 10.7467 20.1874 11.3376 19.4139 11.3376C18.6404 11.3376 18.0127 10.7467 18.0127 10.0188V10.0188Z'
            }
            stroke={'#242424'}
        />
        <circle cx={'34.1503'} cy={'10.6503'} r={'9.65035'} fill={'white'} stroke={'#102035'} />
        <path
            d={
                'M33.7861 8.00549L34.9268 6.8648C35.7938 5.99787 37.2538 5.99787 38.1208 6.8648C38.9877 7.73172 38.9877 9.19181 38.1208 10.0587L36.9801 11.1994'
            }
            stroke={'#A86D37'}
            strokeLinejoin={'round'}
        />
        <path
            d={
                'M34.6987 13.4806L33.558 14.6213C32.6911 15.4882 31.231 15.4882 30.3641 14.6213C29.4971 13.7543 29.4971 12.2942 30.3641 11.4273L31.5048 10.2866'
            }
            stroke={'#A86D37'}
            strokeLinejoin={'round'}
        />
        <path d={'M32.873 12.1119L35.6107 9.37427'} stroke={'#A86D37'} strokeLinejoin={'round'} />
    </svg>
);

export const IconBankWire: React.FC<IconFlexible> = ({ width, height, className }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 45 33'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={'M19.4135 3.42432L4 11.3371V15.2935H34.827V11.3371L19.4135 3.42432Z'}
            stroke={'#242424'}
        />
        <path d={'M16.6104 31.1198V15.2942'} stroke={'#242424'} />
        <path d={'M22.2168 15.2942V31.1198'} stroke={'#242424'} />
        <path d={'M6.80273 31.1198V15.2942'} stroke={'#242424'} />
        <path d={'M12.4072 15.2942V31.1198'} stroke={'#242424'} />
        <path d={'M26.4199 31.1198V15.2942'} stroke={'#242424'} />
        <path d={'M32.0244 15.2942V31.1198'} stroke={'#242424'} />
        <path d={'M0 31.3572H38.857'} stroke={'#242424'} />
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M18.0127 10.0188C18.0127 9.29077 18.6404 8.69995 19.4139 8.69995C20.1874 8.69995 20.8151 9.29077 20.8151 10.0188C20.8151 10.7467 20.1874 11.3376 19.4139 11.3376C18.6404 11.3376 18.0127 10.7467 18.0127 10.0188V10.0188Z'
            }
            stroke={'#242424'}
        />
        <circle cx={'34.1503'} cy={'10.6503'} r={'9.65035'} fill={'white'} stroke={'#102035'} />
        <path
            d={'M37.7129 7.35693L31.7129 12.1569L31.9986 14.2141L33.1529 13.2369'}
            stroke={'#A86D37'}
            strokeLinejoin={'round'}
        />
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={'M29.7139 10.5572L37.7138 7.35718L36.1138 15.3572L29.7139 10.5572Z'}
            stroke={'#A86D37'}
            strokeLinejoin={'round'}
        />
    </svg>
);

export const IconCrypto: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 12 20'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            d={
                'M1 3.18896H7.02301C8.90373 3.18896 10.4284 4.71359 10.4284 6.5943V6.5943C10.4284 8.47502 8.90373 9.99964 7.02301 9.99964H1V3.18896Z'
            }
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            d={
                'M1 10H7.02301C8.90373 10 10.4284 11.5246 10.4284 13.4053V13.4053C10.4284 15.2861 8.90373 16.8107 7.02301 16.8107H1V10Z'
            }
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path d={'M3.48096 3.18915V1'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path d={'M3.48096 19.0002V16.811'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path d={'M6.95459 3.18915V1'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path d={'M6.95459 19.0002V16.811'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
    </svg>
);

export const IconWeChat: React.FC<IconFlexible> = ({ width, height, className }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 34 31'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            d={
                'M32.9962 15.0388C32.9876 15.3739 32.9619 15.709 32.9275 16.0353C32.8846 16.3704 32.8331 16.6967 32.7731 17.0318C32.7044 17.3669 32.6272 17.6932 32.5328 18.0194C32.3268 18.7161 32.0607 19.3951 31.7346 20.0477C31.3828 20.7531 30.9708 21.4233 30.4988 22.0494C30.413 22.1552 30.3272 22.2699 30.2413 22.3757C30.0611 22.5962 29.8809 22.8166 29.6921 23.0283C29.5548 23.1782 29.4261 23.3193 29.2802 23.4604C29.0742 23.6632 28.8682 23.866 28.6537 24.06C28.5421 24.1658 28.4305 24.2628 28.319 24.3598C28.0358 24.5979 27.7526 24.8272 27.4522 25.0477C27.4093 25.0829 27.3664 25.1094 27.3235 25.1447C27.0059 25.3739 26.6798 25.5944 26.3365 25.806C26.2078 25.8854 26.0791 25.9648 25.9417 26.0441C25.7529 26.15 25.5641 26.2646 25.3753 26.3616C25.0578 26.5291 24.7317 26.6879 24.397 26.8378C24.2425 26.9083 24.088 26.9701 23.9336 27.0406C23.7619 27.1112 23.5817 27.1817 23.4015 27.2434C23.0925 27.3669 22.7664 27.4727 22.4489 27.5697C22.1142 27.6755 21.7795 27.7637 21.4362 27.8519C21.1444 27.9224 20.8526 27.9842 20.5694 28.0459C20.5522 28.0459 20.5179 28.0547 20.5007 28.0547C20.1746 28.1165 19.8485 28.1694 19.5224 28.2135C19.1963 28.2575 18.8701 28.2928 18.544 28.3193C18.2179 28.3457 17.8918 28.3634 17.5657 28.3722C17.2396 28.381 16.9134 28.381 16.5873 28.3722C16.2612 28.3634 15.9351 28.3457 15.609 28.3281C15.2829 28.3016 14.9567 28.2752 14.6306 28.2311C14.3388 28.1958 14.047 28.1429 13.7553 28.0988C13.6523 28.0812 13.5493 28.0547 13.4377 28.0459C13.1888 27.993 12.9314 27.9401 12.6825 27.8784C12.3564 27.799 12.0217 27.702 11.6956 27.6138C11.378 27.5256 11.0262 27.5521 10.7258 27.6755L10.0564 28.0547C9.94483 28.1165 9.83326 28.187 9.73028 28.2487C9.41274 28.4427 9.08662 28.6279 8.76909 28.8219C8.62319 28.9101 8.48588 28.9895 8.34857 29.0777C8.16835 29.1835 7.97954 29.2981 7.79932 29.4039C7.46462 29.5979 7.1385 29.8096 6.8038 29.9859C6.5635 30.0389 6.28888 29.9419 6.17731 29.7038C6.07433 29.5098 6.1344 29.2893 6.19448 29.0953C6.2803 28.7602 6.36612 28.4339 6.45194 28.0988C6.53776 27.7637 6.62358 27.4374 6.7094 27.1023C6.76089 26.926 6.8038 26.7408 6.84671 26.5644C6.88962 26.3969 6.94111 26.2381 6.96686 26.0618C6.99261 25.8325 6.94111 25.6032 6.83813 25.4004C6.75231 25.2593 6.64932 25.1447 6.52059 25.0477C6.28888 24.8713 6.06575 24.6949 5.84261 24.5186C5.67097 24.3775 5.50791 24.2276 5.33627 24.0776C5.1818 23.9365 5.0359 23.7955 4.88142 23.6455C4.68404 23.4515 4.49523 23.2487 4.31501 23.0459C4.16912 22.8783 4.02322 22.7196 3.88591 22.5521C3.75718 22.3933 3.62845 22.2258 3.5083 22.0671C3.31091 21.8025 3.12211 21.5203 2.9333 21.2381C2.89897 21.1852 2.86465 21.1235 2.83032 21.0618C2.63293 20.7443 2.45271 20.4092 2.28107 20.0741C2.16092 19.836 2.04935 19.5891 1.94637 19.351C1.91204 19.254 1.86913 19.1658 1.8348 19.0688C1.69749 18.7337 1.58592 18.381 1.48294 18.0371C1.38853 17.7108 1.3113 17.3933 1.24264 17.0582C1.17398 16.7231 1.12249 16.3792 1.07958 16.0441C0.959433 15.0388 0.976597 14.0247 1.12249 13.0194C1.17398 12.6931 1.22548 12.3669 1.30271 12.0494C1.37995 11.7143 1.46577 11.3792 1.57734 11.0529C1.68032 10.709 1.81764 10.3739 1.94637 10.0476L1.95495 10.0212C2.10084 9.68608 2.25532 9.3598 2.42696 9.03352C2.80457 8.32806 3.24226 7.65786 3.74001 7.03176C3.80009 6.96121 3.86016 6.89066 3.91165 6.82012C4.13479 6.55557 4.35792 6.29102 4.59822 6.0441C4.68404 5.95592 4.76986 5.86773 4.86426 5.77073C5.11314 5.52382 5.3706 5.28572 5.63664 5.05645C5.71388 4.9859 5.79112 4.92417 5.86836 4.86244C6.47768 4.3598 7.12134 3.90124 7.79932 3.4956C8.06536 3.33687 8.3314 3.18695 8.60603 3.03704C8.6661 3.00177 8.73476 2.97531 8.79483 2.94004C9.11237 2.78131 9.43849 2.62258 9.76461 2.48148C10.3997 2.20812 11.0519 1.97002 11.7127 1.7672C12.0646 1.66138 12.4165 1.56437 12.7683 1.48501C13.0601 1.41446 13.3519 1.35273 13.6523 1.29982C14.0127 1.22928 14.3732 1.18519 14.7336 1.13228C15.3258 1.06173 15.9179 1.01764 16.5101 1H17.4455C18.1407 1.01764 18.8272 1.07055 19.5224 1.16755C19.8485 1.21164 20.1746 1.26455 20.4922 1.32628C20.8183 1.38801 21.1444 1.45855 21.4619 1.53792C21.788 1.61729 22.1142 1.70547 22.4403 1.81129C23.1097 2.01411 23.7619 2.26984 24.4056 2.55203C24.7317 2.69312 25.0492 2.86067 25.3668 3.0194L25.3925 3.02822C25.71 3.20459 26.0362 3.38096 26.3451 3.57496C27.0317 3.99824 27.6839 4.47443 28.3018 5.00354C28.319 5.01235 28.3447 5.03881 28.3533 5.04763C28.6623 5.321 28.9626 5.59436 29.2544 5.89419C29.3059 5.9471 29.3488 5.99119 29.4003 6.0441C29.632 6.2822 29.8466 6.53793 30.0697 6.79366C29.941 6.84657 29.8122 6.9083 29.6921 6.97003C29.5462 7.03176 29.4003 7.1023 29.2544 7.16403C28.9369 7.30513 28.6193 7.45504 28.3018 7.60495C28.0186 7.73723 27.7354 7.86068 27.4522 7.99296C27.4093 8.0106 27.3664 8.02823 27.332 8.04587C27.0059 8.19578 26.6798 8.34569 26.3537 8.49561C25.7015 8.79543 25.0492 9.09525 24.397 9.39508C23.7533 9.68608 23.1011 9.98591 22.4574 10.2857C22.1313 10.4356 21.8052 10.5856 21.4791 10.7355C21.2731 10.8237 21.0757 10.9207 20.8698 11.0177C20.741 11.0706 20.6209 11.1323 20.4922 11.1852C20.166 11.3351 19.8313 11.485 19.5052 11.6349C19.2392 11.7584 18.9731 11.8819 18.7071 12.0053C18.6556 12.0318 18.5955 12.0582 18.544 12.0759C18.2179 12.2258 17.8918 12.3757 17.5657 12.5256C16.9134 12.8254 16.2612 13.1252 15.609 13.4251C15.1112 13.6543 14.6135 13.8836 14.1157 14.1129C13.9698 14.1834 13.8153 14.2452 13.6609 14.2804C13.3347 14.3334 13 14.2981 12.6997 14.157C12.631 14.1217 12.5538 14.0776 12.4851 14.0335C12.2362 13.8483 11.9788 13.6632 11.7299 13.478C11.5239 13.3281 11.318 13.1782 11.112 13.0282C10.9918 12.9401 10.8631 12.8519 10.743 12.7549C10.4254 12.5256 10.1079 12.2875 9.79893 12.0582C9.79035 12.0582 9.78177 12.0494 9.77319 12.0406C9.54147 11.873 9.31834 11.7055 9.08662 11.5379C9.0008 11.4762 8.89782 11.4321 8.79483 11.4057C8.45155 11.388 8.15118 11.7231 8.22842 12.0759C8.50305 12.7372 8.812 13.3898 9.09521 14.0512C9.24968 14.3951 9.39558 14.739 9.55005 15.0829C9.61013 15.2152 9.6702 15.3563 9.73028 15.4886C9.8161 15.6826 9.90192 15.8766 9.98774 16.0706C10.1336 16.3969 10.2795 16.732 10.4254 17.0582C10.5198 17.2699 10.6142 17.4815 10.7086 17.6932C10.7601 17.8166 10.8202 17.9401 10.8717 18.0635C11.0433 18.4163 11.1549 18.8043 11.3866 19.1129C11.481 19.2011 11.584 19.2805 11.6956 19.351C12.0217 19.5186 12.4165 19.4921 12.734 19.3069C12.8456 19.2364 12.9571 19.1746 13.0687 19.1041C13.2747 18.9895 13.4806 18.866 13.6866 18.7425C14.3388 18.3545 14.9911 17.9665 15.6433 17.5785C15.9265 17.411 16.2011 17.2434 16.4843 17.0759C16.5273 17.0494 16.5787 17.023 16.6217 16.9965C16.9478 16.8025 17.2739 16.6085 17.5914 16.4233C17.7716 16.3175 17.9605 16.2029 18.1407 16.097C18.2866 16.0088 18.4239 15.9295 18.5698 15.8413C18.8959 15.6473 19.2134 15.4533 19.5395 15.2681C19.6425 15.2064 19.7369 15.1535 19.8313 15.0917C20.0631 14.9595 20.2862 14.8184 20.5179 14.6861C21.1701 14.2981 21.8224 13.9189 22.4746 13.5309C22.7235 13.381 22.9724 13.2399 23.2212 13.09C23.2985 13.0459 23.3671 13.0018 23.4444 12.9577C23.7705 12.7637 24.0966 12.5785 24.4227 12.3757C24.5944 12.2787 24.766 12.1729 24.9291 12.0759C25.0835 11.9877 25.238 11.8995 25.3925 11.8025C26.0533 11.4145 26.7055 11.0177 27.3664 10.6296C27.6753 10.4445 27.9843 10.2681 28.2932 10.0829C28.319 10.0653 28.3447 10.0565 28.3705 10.0388C28.6966 9.85363 29.0141 9.65963 29.3317 9.46562C29.5634 9.33335 29.7865 9.19226 30.0182 9.05998C30.1126 9.00707 30.1984 8.95416 30.2928 8.89243C30.6018 8.71606 30.9022 8.52206 31.2197 8.36333C31.3313 8.60143 31.4772 8.81307 31.5887 9.05116C31.7604 9.38626 31.932 9.73018 32.0779 10.0741C32.1208 10.1711 32.1637 10.2769 32.1981 10.3739C32.2925 10.6032 32.3697 10.8413 32.4469 11.0794C32.5499 11.3968 32.6357 11.7231 32.713 12.0494C32.7902 12.3845 32.8503 12.7196 32.9018 13.0547C32.9447 13.3898 32.979 13.7161 32.9962 14.0512C32.9962 14.3686 33.0048 14.7037 32.9962 15.0388Z'
            }
            stroke={'#102035'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
    </svg>
);

export const IconGlobe: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 22 24'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            d={
                'M10.9999 23C9.04194 21.417 8.91694 16.208 11.9999 15C13.6359 14.359 14.1659 17.937 17.3749 17.042C17.9959 16.868 19.4579 17.75 18.9259 19.093'
            }
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            d={
                'M5.29454 4.78662C5.92554 5.25262 6.41854 5.85762 6.88354 6.63562C7.28854 7.31462 8.18954 9.20562 7.36354 10.2726C6.43054 11.4796 3.72754 11.8876 3.72754 12.9996C3.72754 13.8376 4.91254 14.7926 5.54554 15.7276C6.49754 17.1326 6.06454 18.4946 5.54554 19.3636C5.27654 19.8146 4.81854 20.1746 4.34254 20.4616'
            }
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            d={
                'M19.189 7.25924C20.33 8.88424 21 10.8642 21 13.0002C21 18.5232 16.523 23.0002 11 23.0002C5.477 23.0002 1 18.5232 1 13.0002C1 7.47724 5.477 3.00024 11 3.00024C11.494 3.00024 11.98 3.03624 12.455 3.10524'
            }
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={'M20 5C20 7.469 16 11 16 11C16 11 12 7.469 12 5C12 2.469 14.067 1 16 1C17.933 1 20 2.469 20 5V5Z'}
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
    </svg>
);

export const IconDomestic: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 22 22'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M1 11C1 5.477 5.477 1 11 1C16.523 1 21 5.477 21 11C21 16.523 16.523 21 11 21C5.477 21 1 16.523 1 11V11Z'
            }
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path d={'M11.3706 11.3704H21.0002'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path d={'M11.3706 6H19.5002'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path d={'M3 17H19'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path d={'M11 1V11.3704H1'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
        <path
            d={
                'M8.40726 6.92603L8.73988 7.9497H9.81624L8.94544 8.58237L9.27806 9.60605L8.40726 8.97338L7.53647 9.60605L7.86908 8.58237L6.99829 7.9497H8.07465L8.40726 6.92603Z'
            }
            fill={'#FAE8D1'}
        />
        <path
            d={
                'M8.40726 3.22217L8.73988 4.24585H9.81624L8.94544 4.87851L9.27806 5.90219L8.40726 5.26953L7.53647 5.90219L7.86908 4.87851L6.99829 4.24585H8.07465L8.40726 3.22217Z'
            }
            fill={'#FAE8D1'}
        />
        <path
            d={
                'M4.70365 6.92603L5.03626 7.9497H6.11262L5.24183 8.58237L5.57444 9.60605L4.70365 8.97338L3.83286 9.60605L4.16547 8.58237L3.29468 7.9497H4.37104L4.70365 6.92603Z'
            }
            fill={'#FAE8D1'}
        />
    </svg>
);

export const IconSuccess: React.FC<IconFlexible> = ({ width, height, className, stroke }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 111 106'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            d={
                'M101.5 39.6719C102.5 43.6719 103 48.1719 103 52.6719C103 80.1719 80.4999 102.672 52.9999 102.672C25.5 102.672 3 80.1719 3 52.6719C3 25.1719 25.5 2.67188 52.9999 2.67188C62.4999 2.67188 71.4999 5.17188 79.4999 10.1719'
            }
            stroke={stroke}
            strokeWidth={'5'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            d={'M33 42.6719L53 62.6719L108 7.67188'}
            stroke={stroke}
            strokeWidth={'5'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
    </svg>
);

export const IconPDF: React.FC<IconFlexible> = ({ width, height, className, stroke }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox={'0 0 21 23'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            d={
                'M4.85162 13.9452H3.89209V15.3762H4.85162C5.23687 15.3762 5.54162 15.037 5.54162 14.6805C5.5409 14.2787 5.23687 13.9452 4.85162 13.9452Z'
            }
            fill={stroke}
        />
        <path
            d={'M8.71355 13.9739H7.75977V16.5484H8.71355C10.2653 16.5484 10.3336 13.9739 8.71355 13.9739Z'}
            fill={stroke}
        />
        <path
            d={
                'M16.5312 10.7812H0.71875C0.323437 10.7812 0 11.1047 0 11.5V18.6875C0 19.0828 0.323437 19.4062 0.71875 19.4062H16.5312C16.9273 19.4062 17.25 19.0828 17.25 18.6875V11.5C17.25 11.1047 16.9273 10.7812 16.5312 10.7812ZM4.85156 16.095H3.89203V16.854C3.89203 17.107 3.73103 17.25 3.52403 17.25C3.33428 17.25 3.13375 17.107 3.13375 16.8533V13.6182C3.13375 13.4284 3.28325 13.2207 3.52403 13.2207H4.85156C5.59906 13.2207 6.27181 13.7209 6.27181 14.6805C6.27109 15.589 5.59906 16.095 4.85156 16.095ZM8.76516 17.25H7.39738C7.20762 17.25 7.00062 17.1458 7.00062 16.8935V13.6297C7.00062 13.4227 7.20762 13.2732 7.39738 13.2732H8.71341C11.3397 13.2732 11.2822 17.25 8.76516 17.25ZM13.8862 14.0199H12.213V14.9335H13.6785C13.8863 14.9335 14.0925 15.1405 14.0925 15.3417C14.0925 15.5315 13.8863 15.686 13.6785 15.686H12.213V16.8928C12.213 17.094 12.07 17.2493 11.8687 17.2493C11.6157 17.2493 11.4605 17.094 11.4605 16.8928V13.6289C11.4605 13.4219 11.6164 13.2724 11.8687 13.2724H13.8862C14.1392 13.2724 14.288 13.4219 14.288 13.6289C14.288 13.8137 14.1392 14.0199 13.8862 14.0199Z'
            }
            fill={stroke}
        />
        <path
            d={
                'M19.4062 5.45244L14.6726 0.71875C14.2571 0.301875 13.5269 0 12.9375 0H5.03125C3.84244 0 2.875 0.967437 2.875 2.15625V9.34375C2.875 9.74122 3.19628 10.0625 3.59375 10.0625C3.99122 10.0625 4.3125 9.74122 4.3125 9.34375V2.15625C4.3125 1.76022 4.6345 1.4375 5.03125 1.4375H11.5C12.2942 1.4375 12.9375 2.0815 12.9375 2.875V5.57031C12.9375 6.46012 13.6663 7.1875 14.5547 7.1875H17.25C18.0442 7.1875 18.6875 7.8315 18.6875 8.625V20.8438C18.6875 21.2398 18.3662 21.5625 17.9688 21.5625H5.03125C4.6345 21.5625 4.3125 21.2398 4.3125 20.8438C4.3125 20.4463 3.99122 20.125 3.59375 20.125C3.19628 20.125 2.875 20.4463 2.875 20.8438C2.875 22.0326 3.84244 23 5.03125 23H17.9688C19.1576 23 20.125 22.0326 20.125 20.8438V7.1875C20.125 6.59884 19.8231 5.86859 19.4062 5.45244Z'
            }
            fill={stroke}
        />
    </svg>
);

export const IconCollection: React.FC<IconFlexible> = ({ width, height, className, stroke }) => (
    <svg
        width={width}
        height={height}
        viewBox={'0 0 18 18'}
        className={className}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M15.75 0.75H5.25C4.425 0.75 3.75 1.425 3.75 2.25V12.75C3.75 13.575 4.425 14.25 5.25 14.25H15.75C16.575 14.25 17.25 13.575 17.25 12.75V2.25C17.25 1.425 16.575 0.75 15.75 0.75ZM1.5 3.75C1.0875 3.75 0.75 4.0875 0.75 4.5V15.75C0.75 16.575 1.425 17.25 2.25 17.25H13.5C13.9125 17.25 14.25 16.9125 14.25 16.5C14.25 16.0875 13.9125 15.75 13.5 15.75H3C2.5875 15.75 2.25 15.4125 2.25 15V4.5C2.25 4.0875 1.9125 3.75 1.5 3.75ZM6 12.75H15C15.4125 12.75 15.75 12.4125 15.75 12V3C15.75 2.5875 15.4125 2.25 15 2.25H6C5.5875 2.25 5.25 2.5875 5.25 3V12C5.25 12.4125 5.5875 12.75 6 12.75Z'
            }
            fill={stroke}
        />
    </svg>
);

export const IconPaperClip: React.FC<IconFlexible> = ({ width, height, className, stroke }) => (
    <svg
        width={width}
        height={height}
        viewBox={'0 0 20 21'}
        fill={'none'}
        className={className}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            d={
                'M19 9.97157L11.0302 18.2386C8.76604 20.5871 4.96226 20.5871 2.69811 18.2386C0.433962 15.89 0.433962 11.9444 2.69811 9.5958L9.76226 2.26823C11.3925 0.577256 13.9283 0.577256 15.5585 2.26823C17.1887 3.95921 17.1887 6.58962 15.5585 8.28059L9.03774 14.9506C8.13208 15.89 6.68302 15.89 5.86792 14.9506C4.96226 14.0111 4.96226 12.508 5.86792 11.6625L11.3019 6.02596'
            }
            stroke={stroke}
            strokeWidth={'1.5'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
    </svg>
);

export const IconSpinner: React.FC<IconFixed> = ({ className }) => (
    <svg
        role={'status'}
        className={className}
        viewBox={'0 0 100 101'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
    >
        <path
            d={
                'M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
            }
            fill={'currentColor'}
        />
        <path
            d={
                'M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
            }
            fill={'currentFill'}
        />
    </svg>
);

export const IconDownload: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 12 14'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M6.75 7.75H8.0925C8.43 7.75 8.595 8.155 8.3625 8.3875L6.27 10.48C6.12 10.63 5.8875 10.63 5.7375 10.48L3.645 8.3875C3.405 8.155 3.57 7.75 3.9075 7.75H5.25V1C5.25 0.5875 5.5875 0.25 6 0.25C6.4125 0.25 6.75 0.5875 6.75 1V7.75ZM0.75 13.75C0.3375 13.75 0 13.4125 0 13C0 12.5875 0.3375 12.25 0.75 12.25H11.25C11.6625 12.25 12 12.5875 12 13C12 13.4125 11.6625 13.75 11.25 13.75H0.75Z'
            }
            fill={'#242E35'}
        />
    </svg>
);

export const IconList: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 18 18'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            d={'M6 4.5H15.75M6 9H15.75M6 13.5H15.75M2.25 4.5H2.2575M2.25 9H2.2575M2.25 13.5H2.2575'}
            stroke={'#242E35'}
            stroke-width={'1.5'}
            stroke-linecap={'round'}
            stroke-linejoin={'round'}
        />
    </svg>
);

export const IconGrid: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 18 18'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            d={'M7.5 2.25H2.25V7.5H7.5V2.25Z'}
            stroke={'#242E35'}
            stroke-width={'1.5'}
            stroke-linecap={'round'}
            stroke-linejoin={'round'}
        />
        <path
            d={'M15.75 2.25H10.5V7.5H15.75V2.25Z'}
            stroke={'#242E35'}
            stroke-width={'1.5'}
            stroke-linecap={'round'}
            stroke-linejoin={'round'}
        />
        <path
            d={'M15.75 10.5H10.5V15.75H15.75V10.5Z'}
            stroke={'#242E35'}
            stroke-width={'1.5'}
            stroke-linecap={'round'}
            stroke-linejoin={'round'}
        />
        <path
            d={'M7.5 10.5H2.25V15.75H7.5V10.5Z'}
            stroke={'#242E35'}
            stroke-width={'1.5'}
            stroke-linecap={'round'}
            stroke-linejoin={'round'}
        />
    </svg>
);

export const IconDownloadV2: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 17 17'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            d={
                'M14.875 10.625V13.4583C14.875 13.8341 14.7257 14.1944 14.4601 14.4601C14.1944 14.7257 13.8341 14.875 13.4583 14.875H3.54167C3.16594 14.875 2.80561 14.7257 2.53993 14.4601C2.27426 14.1944 2.125 13.8341 2.125 13.4583V10.625M4.95833 7.08333L8.5 10.625M8.5 10.625L12.0417 7.08333M8.5 10.625V2.125'
            }
            stroke={'#242E35'}
            stroke-width={'1.5'}
            stroke-linecap={'round'}
            stroke-linejoin={'round'}
        />
    </svg>
);

export const IconSearch: React.FC<IconFlexible> = ({ width, height, className, stroke }) => (
    <svg
        xmlns={'http://www.w3.org/2000/svg'}
        id={'sbx-icon-search-13'}
        viewBox={'0 0 40 40'}
        width={width}
        height={height}
        className={className}
    >
        <path
            d={
                'M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z'
            }
            fillRule={'evenodd'}
            fill={stroke}
        />
    </svg>
);

export const IconTriangle: React.FC<IconFlexible> = ({ width, height, className, stroke }) => (
    <svg
        width={width}
        height={height}
        viewBox={'0 0 8 6'}
        fill={stroke}
        xmlns={'http://www.w3.org/2000/svg'}
        className={className}
    >
        <path
            d={
                'M3.20759 0.534249C3.6079 0.014241 4.3921 0.0142405 4.79241 0.534248L7.76062 4.39008C8.26682 5.04765 7.79806 6.00007 6.96822 6.00007L1.03178 6.00007C0.201942 6.00007 -0.266823 5.04765 0.239374 4.39008L3.20759 0.534249Z'
            }
            fill={stroke}
        />
    </svg>
);

export const IconEmail: React.FC<IconFlexible> = ({ width, height, className, stroke }) => {
    return (
        <svg width={width} height={height} viewBox={'0 0 20 20'} fill={stroke} className={className}>
            <path
                d={
                    'M3.33341 3.3335H16.6667C17.5834 3.3335 18.3334 4.0835 18.3334 5.00016V15.0002C18.3334 15.9168 17.5834 16.6668 16.6667 16.6668H3.33341C2.41675 16.6668 1.66675 15.9168 1.66675 15.0002V5.00016C1.66675 4.0835 2.41675 3.3335 3.33341 3.3335Z'
                }
                stroke={'white'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
            <path
                d={'M18.3334 5L10.0001 10.8333L1.66675 5'}
                stroke={'white'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    );
};

export const IconFilledCheck: React.FC<IconFlexible> = ({ width, height, className, stroke }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox={'0 0 24 24'}
            fill={stroke}
            xmlns={'http://www.w3.org/2000/svg'}
            className={className}
        >
            <path
                fillRule={'evenodd'}
                clipRule={'evenodd'}
                d={
                    'M12 1C18.075 1 23 5.925 23 12C23 18.075 18.075 23 12 23C5.925 23 1 18.075 1 12C1 5.925 5.925 1 12 1V1Z'
                }
                stroke={stroke}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
            <path
                fillRule={'evenodd'}
                clipRule={'evenodd'}
                d={
                    'M17.5656 8.66437C17.9325 8.25159 17.8953 7.61952 17.4825 7.2526C17.0698 6.88568 16.4377 6.92286 16.0708 7.33565L10.2299 13.9066L7.70711 11.3838C7.31658 10.9933 6.68342 10.9933 6.29289 11.3838C5.90237 11.7743 5.90237 12.4075 6.29289 12.798L9.55932 16.0644C9.56848 16.0738 9.57786 16.0829 9.58746 16.0919C9.67181 16.1714 9.76659 16.2334 9.86723 16.278C10.1443 16.401 10.4635 16.3907 10.7312 16.2526C10.8294 16.2021 10.9206 16.1343 11.0003 16.0497C11.0091 16.0404 11.0176 16.031 11.026 16.0214L17.5656 8.66437Z'
                }
                fill={'white'}
            />
        </svg>
    );
};

export const IconBank: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 22 21'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={'M11 1L1 6.45455V9.18182H21V6.45455L11 1Z'}
            stroke={'#FAE8D1'}
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            d={'M2.81836 20.0907V9.18164'}
            stroke={'#FAE8D1'}
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            d={'M8.45508 9.18164V20.0907'}
            stroke={'#FAE8D1'}
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            d={'M13.5449 20.0907V9.18164'}
            stroke={'#FAE8D1'}
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            d={'M19.1816 9.18164V20.0907'}
            stroke={'#FAE8D1'}
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            d={'M1 20.0908H21'}
            stroke={'#FAE8D1'}
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M10.0908 5.54532C10.0908 5.0435 10.4981 4.63623 10.9999 4.63623C11.5017 4.63623 11.909 5.0435 11.909 5.54532C11.909 6.04714 11.5017 6.45441 10.9999 6.45441C10.4981 6.45441 10.0908 6.04714 10.0908 5.54532V5.54532Z'
            }
            stroke={'#FAE8D1'}
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
    </svg>
);

export const IconMailACheck: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 20 18'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            d={'M14.0909 8.36377H19V17.3638H1V8.36377H5.09091'}
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={'M7.54537 10.8182H5.09082V8.36364L12.4545 1L14.909 3.45455L7.54537 10.8182Z'}
            strokeWidth={'1.2'}
            strokeLinecap={'round'}
            strokeLinejoin={'round'}
        />
        <path d={'M5.09082 14.0908H14.909'} strokeWidth={'1.2'} strokeLinecap={'round'} strokeLinejoin={'round'} />
    </svg>
);

export const IconMoney: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 12 17'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            d={
                'M6.29896 7.78164C4.86912 7.61031 3.08829 7.397 3.08829 5.86954C3.08829 4.58626 4.24701 3.84928 6.26937 3.84928C7.49691 3.84928 8.77333 4.38048 9.39814 5.12017L10.7406 4.49815C10.0931 3.40202 9.06305 2.79514 7.44941 2.54888L7.15836 2.50484V1H5.57576V2.51448L5.27439 2.55095C4.37437 2.65897 1.43415 3.22183 1.43415 5.8703C1.43415 8.48577 3.49228 8.92473 6.18261 9.22542C7.66267 9.40088 9.62915 9.81235 9.62915 11.3688C9.62915 12.7807 8.31492 13.658 6.19776 13.658C4.82711 13.658 3.18473 13.0491 2.48488 11.88L1 12.5103C2.01355 14.4652 4.08402 14.9399 5.26475 15.0459L5.57645 15.0742V16.74H7.15905V14.9792L7.47694 14.9551C9.42498 14.8147 11.3901 13.6505 11.3901 11.3696C11.3901 8.6317 9.08494 8.12355 6.29896 7.78164Z'
            }
            fill={'#51AC55'}
            stroke={'#51AC55'}
            strokeWidth={'0.3'}
        />
    </svg>
);

export const IconHome: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 16 17'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={
                'M7.15114 2.09331C7.63056 1.63833 8.38132 1.63521 8.8645 2.08618L12.869 5.82367C13.1718 6.10629 13.6464 6.08993 13.929 5.78712C14.2116 5.4843 14.1952 5.00971 13.8924 4.72708L9.88798 0.989598C8.82497 -0.00254884 7.1733 0.00432141 6.11857 1.00528L0.933139 5.92635C0.386006 6.4456 0.0761719 7.16678 0.0761719 7.92108V14.0364C0.0761719 15.5552 1.30739 16.7864 2.82617 16.7864H5.95047H10.0499H13.1742C14.693 16.7864 15.9242 15.5552 15.9242 14.0364V12.5919V10.2972C15.9242 9.88297 15.5884 9.54718 15.1742 9.54718C14.76 9.54718 14.4242 9.88297 14.4242 10.2972V12.5919V14.0364C14.4242 14.7268 13.8646 15.2864 13.1742 15.2864H10.185V10.797C10.185 10.1067 9.62533 9.54701 8.93497 9.54701H7.06537C6.37501 9.54701 5.81537 10.1067 5.81537 10.797V15.2864H2.82617C2.13582 15.2864 1.57617 14.7268 1.57617 14.0364V7.92108C1.57617 7.57822 1.71701 7.2504 1.9657 7.01439L7.15114 2.09331ZM7.31537 15.2862V11.047H8.68497V15.2862H7.31537Z'
            }
            fill={'#242E35'}
        />
    </svg>
);

export const IconAvatar: React.FC<IconFixed> = ({ className }) => (
    <svg className={className} viewBox={'0 0 14 15'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
            d={
                'M7.00095 7.85547C8.99314 7.85547 10.501 6.04297 10.501 3.64453C10.501 1.73047 8.89939 0.105469 7.00095 0.105469C5.10251 0.105469 3.50095 1.73047 3.50095 3.64453C3.50095 6.04297 5.00876 7.85547 7.00095 7.85547ZM7.00095 1.31641C8.21189 1.31641 9.2822 2.41016 9.2822 3.64453C9.2822 5.35547 8.30564 6.64453 7.00095 6.64453C5.69626 6.64453 4.7197 5.35547 4.7197 3.64453C4.7197 2.41016 5.79001 1.31641 7.00095 1.31641ZM1.75876 14.1055L1.86814 12.9414C2.11033 10.5977 4.7822 10.082 7.00095 10.082C9.2197 10.082 11.8916 10.5977 12.1338 12.9336L12.2431 14.1055H13.4931L13.3838 12.8164C13.1103 10.2617 10.8603 8.85547 7.00095 8.85547C3.14158 8.85547 0.891576 10.2617 0.618138 12.8242L0.508763 14.1055H1.75876Z'
            }
            fill={'#242E35'}
        />
        <path
            d={
                'M1.75876 14.1055V14.3055H1.94085L1.95789 14.1242L1.75876 14.1055ZM1.86814 12.9414L1.66919 12.9208L1.66902 12.9227L1.86814 12.9414ZM12.1338 12.9336L12.3329 12.915L12.3327 12.913L12.1338 12.9336ZM12.2431 14.1055L12.044 14.1241L12.0609 14.3055H12.2431V14.1055ZM13.4931 14.1055V14.3055H13.7108L13.6924 14.0886L13.4931 14.1055ZM13.3838 12.8164L13.5831 12.7995L13.5826 12.7951L13.3838 12.8164ZM0.618138 12.8242L0.419223 12.803L0.418863 12.8072L0.618138 12.8242ZM0.508763 14.1055L0.309488 14.0885L0.290963 14.3055H0.508763V14.1055ZM7.00095 8.05547C9.13658 8.05547 10.701 6.11726 10.701 3.64453H10.301C10.301 5.96867 8.8497 7.65547 7.00095 7.65547V8.05547ZM10.701 3.64453C10.701 1.62231 9.01213 -0.0945311 7.00095 -0.0945311V0.305469C8.78664 0.305469 10.301 1.83862 10.301 3.64453H10.701ZM7.00095 -0.0945311C4.98977 -0.0945311 3.30095 1.62231 3.30095 3.64453H3.70095C3.70095 1.83862 5.21526 0.305469 7.00095 0.305469V-0.0945311ZM3.30095 3.64453C3.30095 6.11726 4.86532 8.05547 7.00095 8.05547V7.65547C5.15221 7.65547 3.70095 5.96867 3.70095 3.64453H3.30095ZM7.00095 1.51641C8.09754 1.51641 9.0822 2.51668 9.0822 3.64453H9.4822C9.4822 2.30363 8.32624 1.11641 7.00095 1.11641V1.51641ZM9.0822 3.64453C9.0822 5.29954 8.1476 6.44453 7.00095 6.44453V6.84453C8.46368 6.84453 9.4822 5.4114 9.4822 3.64453H9.0822ZM7.00095 6.44453C5.85431 6.44453 4.9197 5.29954 4.9197 3.64453H4.5197C4.5197 5.4114 5.53822 6.84453 7.00095 6.84453V6.44453ZM4.9197 3.64453C4.9197 2.51668 5.90436 1.51641 7.00095 1.51641V1.11641C5.67566 1.11641 4.5197 2.30363 4.5197 3.64453H4.9197ZM1.95789 14.1242L2.06726 12.9601L1.66902 12.9227L1.55964 14.0868L1.95789 14.1242ZM2.06708 12.962C2.17869 11.8819 2.84296 11.2184 3.77272 10.8164C4.7113 10.4105 5.90187 10.282 7.00095 10.282V9.88203C5.88128 9.88203 4.62654 10.0114 3.61395 10.4492C2.59253 10.8909 1.79978 11.6572 1.6692 12.9208L2.06708 12.962ZM7.00095 10.282C8.10002 10.282 9.29068 10.4105 10.2293 10.8155C11.1593 11.2167 11.8233 11.8783 11.9348 12.9542L12.3327 12.913C12.2021 11.6529 11.409 10.8888 10.3878 10.4482C9.37529 10.0114 8.12063 9.88203 7.00095 9.88203V10.282ZM11.9346 12.9522L12.044 14.1241L12.4423 14.0869L12.3329 12.915L11.9346 12.9522ZM12.2431 14.3055H13.4931V13.9055H12.2431V14.3055ZM13.6924 14.0886L13.583 12.7995L13.1845 12.8333L13.2939 14.1224L13.6924 14.0886ZM13.5826 12.7951C13.4393 11.4559 12.7736 10.4112 11.6427 9.70808C10.5201 9.01017 8.95116 8.65547 7.00095 8.65547V9.05547C8.91012 9.05547 10.3958 9.40389 11.4315 10.0478C12.4588 10.6865 13.0548 11.6222 13.1849 12.8377L13.5826 12.7951ZM7.00095 8.65547C5.05076 8.65547 3.48171 9.01016 2.35911 9.70913C1.22813 10.4133 0.562566 11.4601 0.419267 12.803L0.817009 12.8454C0.947148 11.6259 1.54331 10.6883 2.57053 10.0487C3.60613 9.4039 5.09177 9.05547 7.00095 9.05547V8.65547ZM0.418863 12.8072L0.309488 14.0885L0.708039 14.1225L0.817414 12.8412L0.418863 12.8072ZM0.508763 14.3055H1.75876V13.9055H0.508763V14.3055Z'
            }
            fill={'#242E35'}
        />
    </svg>
);
